import type { IGpthelpToolGate } from './tool-types';

/** `display` of the read tools whose answer shows as a card (plan §9.7). */
export const DISPLAY_PARAM = {
  type: 'boolean',
  description:
    'true when this result directly answers the user; the numbers also show in a card under your reply: state the main figure in one or two sentences and never mention the card.',
};

/**
 * `display` of `stats_products_rank`: its card shows at most
 * `TOP_PRODUCTS_MAX_ROWS` rows (cards/stats-cards.ts; stats-tools.spec.ts pins
 * the «up to 10 rows» literal to it), so the reply still lists every row the
 * user asked for (plan §9.7).
 */
export const LIST_DISPLAY_PARAM = {
  type: 'boolean',
  description:
    'true when this result directly answers the user; up to 10 rows also show in a card under your reply: still list every row the user asked for and never mention the card.',
};

/** Whether this member can open the page `key` on the store's plan. */
export function canOpenPage(gate: IGpthelpToolGate, key: string): boolean {
  return gate.navTargets.some((target) => target.key === key && !target.locked);
}
